import { render, staticRenderFns } from "./collarCard.vue?vue&type=template&id=26352d57&scoped=true"
import script from "./collarCard.vue?vue&type=script&lang=js"
export * from "./collarCard.vue?vue&type=script&lang=js"
import style0 from "./collarCard.vue?vue&type=style&index=0&id=26352d57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26352d57",
  null
  
)

export default component.exports